module.exports = __webpack_public_path__ + "static/media/certMSAF.c08327ce.pdf";